import React, { JSX } from 'react';
import { Box, BoxProps } from '@mui/material';

export const paddedWrapperPx = {
  xs: 0.5,
  sm: 1,
  md: 3,
  lg: 5,
  xl: 8
};

export const paddedWrapperPb = {
  xs: 2,
  sm: 4,
  md: 6
};

export const paddedWrapperMaxWidth = 1850;

export const PaddedWrapper = ({
  children,
  ...boxProps
}: BoxProps): JSX.Element => (
  <Box px={paddedWrapperPx} pb={paddedWrapperPb} {...boxProps}>
    <Box maxWidth={paddedWrapperMaxWidth} width={'100%'} mx="auto">
      {children}
    </Box>
  </Box>
);
